import { ROUTES } from '@/lib/routes';

export const SidebarConfig = {
  [ROUTES.ADMIN]: {
    icon: '/icons/logo_panel.svg',
    links: [
      {
        icon: '/icons/server.svg',
        name: 'Users',
        path: ROUTES.ADMIN_USERS,
        disabled: false,
      },
      {
        name: 'Coaches',
        path: ROUTES.ADMIN_COACHES,
        icon: '/icons/speakerphone.svg',
        disabled: true,
      },
      { name: 'Sessions', path: ROUTES.ADMIN_SESSIONS, icon: '/icons/camera.svg', disabled: false },
    ],
  },
  [ROUTES.CONTENT]: {
    icon: '/icons/logo_content.svg',
    links: [
      { name: 'Explore', path: ROUTES.CONTENT_EXPLORE, icon: '/icons/server.svg', disabled: false },
      {
        name: 'Journeys',
        path: ROUTES.CONTENT_JOURNEYS,
        icon: '/icons/route.svg',
        disabled: false,
      },
    ],
  },
  [ROUTES.COACH]: {
    icon: '/icons/logo.svg',
    links: [
      {
        name: 'Sessions',
        path: ROUTES.COACH,
        disabled: false,
      },
      {
        name: 'Schedule',
        path: ROUTES.COACH_SCHEDULE,
        disabled: false,
      },
      {
        name: 'Calendar',
        path: ROUTES.COACH_CALENDAR,
        disabled: false,
      },
    ],
  },
};
